export const isWindow = (typeof window !== 'undefined') ? true : false;